<template>
  <div>
    <router-view></router-view>
    <v-bottom-navigation app :value="currentTab" grow color="red">
      <v-btn
        v-for="(tab, i) in tabs"
        :key="tab.title"
        @click="changeTab(tab.value, i)"
      >
        <span>{{ tab.title }}</span>
        <v-icon>{{ tab.icon }}</v-icon>
      </v-btn>
    </v-bottom-navigation>
  </div>
</template>

<script>
export default {
  name: "Home",
  components: {},
  data() {
    return {
      tabs: [
        {
          title: "Menu",
          icon: "mdi-menu",
          value: "homepage.menu",
        },
        {
          title: "Transaksi",
          icon: "mdi-history",
          value: "homepage.transaction",
        },
        {
          title: "Profile",
          icon: "mdi-cog",
          value: "homepage.profile",
        },
      ],
    };
  },
  computed: {
    currentTab() {
      return this.tabs.findIndex((r) => {
        return r.value === this.$route.name;
      });
    },
  },
  methods: {
    isTab(tab) {
      return tab === this.currentTab;
    },
    changeTab(val, i) {
      if (this.currentTab === i) return;
      this.$router.push({ name: val });
    },
  },
  created() {},
};
</script>

<style scoped>
.v-item-group.v-bottom-navigation .v-btn.v-size--default {
  height: inherit;
}
</style>
